const storage_keys = {
	USER: "@:user",
};

export default storage_keys;
